import AppConfig from 'config'
import { OpticalMeasureDevScreen } from '@ca/optical-measure/dev'

export default function OpticalMeasureDevRoute() {
  return (
    <OpticalMeasureDevScreen
      isDev={AppConfig.isDev}
      isDebug={AppConfig.isDebug}
    />
  )
}
